import { transitionEnd } from '../animation'

let el

export function BannerAlert() {
    el = document.querySelector('.js-alert')

    if (!el) {
        return
    }

    el.addEventListener('click', (evt) => {
        if (!evt.target.classList.contains('js-alert-btn')) {
            return
        }

        closeAlert()
    })

    transitionEnd(el).subscribe((evt) => {
        if (evt.target !== el) {
            return
        }

        el.remove()
    })
}

function closeAlert() {
    el.classList.add('is-closed')
}
